import { pushLog2DV2LogServer } from "../../services/logging";
import * as dashboardService from "../../services/Dashboard";
import publicIp from "public-ip";

export const FETCH_CLIENT_INFORMATION_BY_IP = async () => {
  try {
    const userIp = await publicIp.v4();
    const result = await dashboardService.getClientInformationDataByIp(userIp);
    if (result.data.data) {
      const clientInformationData = result.data.data;
      pushLog2DV2LogServer.info(
        "SOCIAL_PROOF",
        "FETCH_CLIENT_INFORMATION",
        {},
        clientInformationData,
        null
      );
      return clientInformationData;
      // [LOGGING] - FETCH_CLIENT_INFORMATION
    } else {
      const log_error = {
        message: `Response code from getClientInformation is ${result.status}`,
      };
      // [LOGGING] - FETCH_CLIENT_INFORMATION
      pushLog2DV2LogServer.error(
        "SOCIAL_PROOF",
        "FETCH_CLIENT_INFORMATION",
        {},
        {},
        log_error
      );
      return {};
    }
  } catch (e) {
    console.log(e.message);
    // [LOGGING] - FETCH_CLIENT_INFORMATION
    pushLog2DV2LogServer.error(
      "SOCIAL_PROOF",
      "FETCH_CLIENT_INFORMATION",
      {},
      {},
      e
    );
    return {};
  }
};
